import Container from './ShopPage.container';
import Component from './ShopPage';

export default Container(Component);
